import { useContext } from "react";
import { Box, Button, Chip, CircularProgress } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { ReportEditContext } from "../contexts/reportEdit";

// Admin-only floating control to enter/exit the report editor and save the
// per-team overlay. Hidden entirely for non-admin viewers (clients / shares).
const ReportEditToolbar = () => {
  const { canEdit, editing, setEditing, dirty, saving, save, discard } =
    useContext(ReportEditContext);

  if (!canEdit) return null;

  const handleSave = async () => {
    // Flush the field the admin may still be focused on into the overlay buffer.
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
    // Let the blur commit land before reading the buffer.
    await new Promise((r) => setTimeout(r, 0));
    await save();
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        gap: 1,
        backgroundColor: "#fff",
        boxShadow: 3,
        borderRadius: 2,
        px: 1.5,
        py: 1,
      }}
      className="no-print"
    >
      {!editing ? (
        <Button
          variant="contained"
          size="small"
          startIcon={<EditIcon />}
          onClick={() => setEditing(true)}
        >
          EDIT REPORT
        </Button>
      ) : (
        <>
          <Chip
            size="small"
            color={dirty ? "warning" : "default"}
            label={dirty ? "Unsaved changes" : "Editing"}
          />
          <Button
            variant="contained"
            size="small"
            color="primary"
            startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
            disabled={saving || !dirty}
            onClick={handleSave}
          >
            {saving ? "SAVING..." : "SAVE"}
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<CloseIcon />}
            disabled={saving}
            onClick={() => {
              discard();
              setEditing(false);
            }}
          >
            DONE
          </Button>
        </>
      )}
    </Box>
  );
};

export default ReportEditToolbar;
